import { render } from "./StoreDetails.vue?vue&type=template&id=70187168&scoped=true"
import script from "./StoreDetails.vue?vue&type=script&lang=js"
export * from "./StoreDetails.vue?vue&type=script&lang=js"

import "./StoreDetails.vue?vue&type=style&index=0&id=70187168&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-70187168"]])

export default __exports__